import { render } from "./ParametrizacaoController.vue?vue&type=template&id=4f2e6bf3&scoped=true"
import script from "./ParametrizacaoController.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoController.vue?vue&type=script&lang=js"

import "./ParametrizacaoController.vue?vue&type=style&index=0&id=4f2e6bf3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2e6bf3"]])

export default __exports__